// extracted by mini-css-extract-plugin
export default {"clearAlarm":"RepairStart_clearAlarm__N1JnP","wrap":"RepairStart_wrap__4bEdm","text":"RepairStart_text__e8dtB","spacer":"RepairStart_spacer__vUmvO"};